export default __webpack_public_path__ + "static/media/living-room.fe74cf13.jpg";